import * as React from 'react'
import { TextInputProps } from './types'
import { StyledErrorMessage, StyledTextInput, StyledLabel } from './styled'

export const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  ({ type = 'text', variant = 'default', error = undefined, label, ...rest }, ref) => {
    return (
      <>
        <StyledLabel variant={variant} hasError={!!error}>
          <StyledTextInput ref={ref} placeholder=" " type={type} {...rest} />
          <span>{label}</span>
        </StyledLabel>
        {error && <StyledErrorMessage>{error}</StyledErrorMessage>}
      </>
    )
  },
)
